export default __webpack_public_path__ + "static/media/IMG_1088.b32d91b9.JPG";